import React, { useState, useCallback, useContext } from "react";
import { RecepiesContext } from "../context/RepiesContext";
import recipes from "../API/recipes";

const BASE_KEY = "baselineRecepies";

const SearchBox = () => {
    const { recepies, setRecepies } = useContext(RecepiesContext);
    const [q, setQ] = useState("");

    const submit = useCallback(
        (e) => {
            e.preventDefault();

            // ✅ Snapshot what the user is currently seeing (pre-search)
            try {
                sessionStorage.setItem(BASE_KEY, JSON.stringify(recepies));
            } catch { }

            recipes
                .getRecepies({
                    query: q,
                    cuisine: recepies?.cuisine,
                    diet: recepies?.diet,
                    intolerances: recepies?.intolerances,
                    number: 20,
                    offset: 0,
                })
                .then((res) => setRecepies({ ...res.data, query: q }))
                .catch((err) => console.error("Search failed:", err));
        },
        [q, recepies, setRecepies]
    );

    const clear = useCallback(() => {
        setQ("");

        // ✅ Restore the exact list from before the search
        const raw = sessionStorage.getItem(BASE_KEY);
        if (raw) {
            try {
                const baseline = JSON.parse(raw);
                setRecepies(baseline);
                return;
            } catch { }
        }

        // Fallback: if no snapshot exists, just fetch a fresh random batch
        recipes
            .getRecepies({ number: 20 })
            .then((res) => setRecepies(res.data))
            .catch((err) => console.error("Reset failed:", err));
    }, [setRecepies]);

    return (
        <form onSubmit={submit} className="w-full sm:w-auto flex items-center gap-2">
            <div className="relative w-full sm:w-80">
                <input
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    placeholder='Search recipes (e.g., "chicken tacos")'
                    aria-label="Search recipes"
                    className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 pr-10 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                />
                <button
                    type="submit"
                    className="absolute right-1 top-1 inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-600 hover:bg-gray-100"
                    aria-label="Search"
                >
                    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="11" cy="11" r="7" />
                        <path d="M20 20l-3.5-3.5" />
                    </svg>
                </button>
            </div>
            <button
                type="button"
                onClick={clear}
                className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
                Clear
            </button>
        </form>
    );
};

export default SearchBox;
